module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-regular.789d075.woff2";